import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true,
  state: {
  },
  mutations: {
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/stores/index.js